import { Box } from "@material-ui/core";

const Terms = () => {
  return (
    <Box p={5}>
      <p
        dir="ltr"
        style={{
          lineHeight: "1.295",
          textAlign: "justify",
          marginTop: "0pt",
          marginBottom: "0pt",
        }}
      >
        <span
          style={{
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre-wrap",
          }}
        >
          Terms &amp; Conditions&nbsp;
        </span>
      </p>
      <br />
      <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 700,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.295",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Terms of Use
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "upper-alpha",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              This document is an electronic record which stipulates the terms and conditions access or usage of&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              www.sporting.qa
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;website and&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting application
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;for mobile, handheld or other devices collectively called&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              ‘Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              .
            </span>
            <span
              style={{
                fontSize: "12pt",
                fontFamily: "Arial",
                color: "#282c3f",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Please read these Terms &amp; Conditions carefully before you use our services. If you do not agree to
              these Terms &amp; Conditions, you may restrain from using the services on the&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              ‘Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              , and we request you to then not install the App but reach to our team for any further clarifications. By
              installing, downloading or even merely using the&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              ‘Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              , you shall be contracting with&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              and you signify your acceptance to the Terms &amp; Condition of use and other&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;policies (including but not limited to the Cancellation &amp; Refund Policy, Privacy Policy as
              posted on the&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              ‘Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;from time to time, which takes effect on the date on which you download, install or use the&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              , and create a legally binding arrangement to abide by the same.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "upper-alpha",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "14pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;enables transactions between various online portals, dealing with various services and mainly in the
              use of payments/down payments of administrational, registrational fees,
            </span>
            <span
              style={{
                fontSize: "11pt",
                fontFamily: "Calibri,sans-serif",
                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              provide, third party service providers, e-store purchases, etc. through ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              ‘Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              . The users (" User/s") can choose and place booking, payment or appointment from variety of
              establishments listed and offered for rent/sale/consultation by various third-party vendors, including but
              not limited to hotels, establishments, sport related stores&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              ("&nbsp;Vendor/s")
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              , on the&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              ‘Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;and&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;enables access of reservation channels of such Vendors at select localities of serviceable cities
              across Qatar.&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              ‘Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;are collectively referred to as&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              "&nbsp;Sporting Services"
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              . For additional delivery services rendered, Sporting may charge you delivery fee.
            </span>
          </p>
        </li>
      </ol>
      <ol start={2} style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Use of ‘Sporting Application Channels/Platforms’
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              All commercial/contractual terms are offered by and agreed to between the&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Users
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;and&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Vendors
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;alone. The commercial/contractual terms include without limitation price, taxes, shipping costs (if
              Any), payment methods, payment terms, date, period and mode of booking/delivery, warranties related to
              products and services and after sales services related to products and services.&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;does not have any control or does not determine or advise or in any way involve itself in the
              offering or acceptance of such commercial/contractual terms between the Users and Vendors.&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;may, however, offer support services to Vendors in respect to order fulfilment, payment collection,
              call center, and other services, pursuant to independent contracts executed by it with the Vendors.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;does not make any representation or warranty as to the item-specifics (such as legal title,
              creditworthiness, identity, etc.) of any of the Vendors. You are advised to independently verify the bona
              fides of any particular Vendor that you choose to deal with on the&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              ‘Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;and use your best judgment on that behalf. All Vendor’s offers and third party offers are subject to
              respective party terms and conditions.&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;takes no responsibility for such offers.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;neither make any representation or warranty as to specifics (such as quality, value, salability,
              etc.) of the products or services proposed to be sold or offered to be sold or purchased on the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;nor does implicitly or explicitly support or endorse the sale or purchase of any products or
              services on the Platform.&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;accepts no liability for any errors or omissions, whether on behalf of itself or third parties.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;is operating an online&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              ‘Sporting Application’&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              which lists the services and purchasable/deliverable items and assumes the role of facilitator and does
              not at any point of time during any transaction between User and Vendor on the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;come into or take possession of any of the products or services offered by the Vendor/s. At no time
              shall&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;hold any right, title or interest over the products nor shall&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;have any obligations or liabilities in respect of such contract entered between User/s and Vendor/s.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;is only providing a ‘Platform for communication and it is agreed that the contract for sale of any
              of the products or services shall be a strictly bipartite contract between the Vendor and the User.&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              In case of complaints from the User pertaining to products/services efficacy, quality, or any other such
              issues,&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;shall notify the same to Vendor and shall also redirect the User to the consumer call center of the
              Vendor. The Vendor shall be liable for resolving buyer complaints.&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              In the event the User raise any complaint on any Vendor/s accessed using&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;Platform, we shall assist the User to the best of our abilities by providing relevant information,
              such as details of the Vendor and the specific Order to which the complaint relates, to enable
              satisfactory resolution of the complaint.
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol start={3} style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 700,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Use of the Sporting Website and Apps (Android and iOS).
            </span>
          </p>
        </li>
      </ol>
      <br />
      <p
        dir="ltr"
        style={{
          lineHeight: "1.7999999999999998",
          marginLeft: "36pt",
          textAlign: "justify",
          marginTop: "0pt",
          marginBottom: "0pt",
        }}
      >
        <span
          style={{
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre-wrap",
          }}
        >
          You agree, undertake and confirm that your use of ‘
        </span>
        <span
          style={{
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 700,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre-wrap",
          }}
        >
          Sporting Application Channels/Platforms’
        </span>
        <span
          style={{
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre-wrap",
          }}
        >
          &nbsp;shall be strictly governed by the following binding principles:
        </span>
      </p>
      <p
        dir="ltr"
        style={{
          lineHeight: "1.7999999999999998",
          marginLeft: "36pt",
          textAlign: "justify",
          marginTop: "0pt",
          marginBottom: "0pt",
        }}
      >
        <span
          style={{
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre-wrap",
          }}
        >
          You shall not host, display, upload, download, modify, publish, transmit, update or share any information
          which:
        </span>
      </p>
      <br />
      <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              belongs to another person and which you do not have any rights to
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              is grossly harmful, harassing, blasphemous, defamatory, obscene, pornographic, pedophilic, libelous,
              slanderous, criminally inciting or invasive of another’s privacy, hateful, or racially, ethnically
              objectionable, disparaging, relating or encouraging money laundering or gambling, or otherwise unlawful in
              any manner whatsoever; or unlawfully threatening or unlawfully harassing including but not limited to
              “indecent representation of women”
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              is misleading or misrepresentative in any way.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              is patently offensive to the online community, such as sexually explicit content, or content that promotes
              obscenity, pedophilia, racism, bigotry, hatred or physical harm of any kind against any group or
              individual;
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              harasses or advocates harassment of another person
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              involves the transmission of “junk mail”, “chain letters”, or unsolicited mass mailing or “spamming”
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;promotes illegal activities or conduct that is abusive, threatening, obscene, defamatory or libelous
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              infringes upon or violates any third party’s rights [including, but not limited to, intellectual property
              rights, rights of privacy (including without limitation unauthorized disclosure of a person’s name, email
              address, physical address or phone number) or rights of publicity.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              promotes an illegal or unauthorized copy of another person's copyrighted such as providing pirated
              computer programs or links to them, providing information to circumvent manufacture-installed copy-protect
              devices, or providing pirated music or links to pirated music files
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              contains restricted or password-only access pages, or hidden pages or images (those not linked to or from
              another accessible page)
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              provides material that exploits people in a sexual, violent or otherwise inappropriate manner or solicits
              personal information from anyone
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              provides instructional information about illegal activities such as making or buying illegal weapons,
              violating someone’s privacy, or providing or creating computer viruses
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              contains video, photographs, or images of another person (with a minor or an adult)
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;tries to gain unauthorized access or exceeds the scope of authorized access to the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or to profiles, blogs, communities, account information, bulletins, friend request, or other areas
              of the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or solicits passwords or personal identifying information for commercial or unlawful purposes from
              other users.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              engages in commercial activities and/or sales without our prior written consent such as contests,
              sweepstakes, barter, advertising and pyramid schemes, or the buying or selling of products related to the
              Platform. Throughout these Terms of Use,&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting’s
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;prior written consent means a communication coming from&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting’s Legal Department
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              , specifically in response to your request, and expressly addressing and allowing the activity or conduct
              for which you seek an authorization
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              solicits gambling or engages in any gambling activity which is or could be construed as being illegal
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              backgroundColor: "#ffffff",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              interferes with another user’s use and enjoyment of the ‘‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or any third party’s user and enjoyment of similar services
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              refers to any website or URL that, in our sole discretion, contains material that is inappropriate for the
              ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or any other website, contains content that would be prohibited or violates the letter or spirit of
              these Terms of Use
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              harm minors in any way
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              infringes any patent, trademark, copyright or other intellectual property rights or third party’s trade
              secrets or rights of publicity or privacy or shall not be fraudulent or involve the sale of counterfeit or
              stolen products
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              violates any law for the time being in force
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              deceives or misleads the addressee/users about the origin of such messages or communicates any information
              which is grossly offensive or menacing in nature
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              impersonate another person
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              contains software viruses or any other computer code, files or programs designed to interrupt, destroy or
              limit the functionality of any computer resource; or contains any trojan horses, worms, time bombs,
              cancelbots, easter eggs or other computer programming routines that may damage, detrimentally interfere
              with, diminish value of, surreptitiously intercept or expropriate any system, data or personal information
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              threatens the unity, integrity, defense, security or sovereignty of Qatar, friendly relations with foreign
              states, or public order or causes incitement to the commission of any criminal offence or prevents
              investigation of any offence or is insulting any other nation
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              is false, inaccurate or misleading
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              directly or indirectly, offers, attempts to offer, trades or attempts to trade in any item, the dealing of
              which is prohibited or restricted in any manner under the provisions of any applicable law, rule,
              regulation or guideline for the time being in force; or creates liability for us or causes us to lose (in
              whole or in part) the services of our internet service provider or other suppliers.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You shall not use any “deep-link”, “page-scrape”, “robot”, “spider” or other automatic device, program,
              algorithm or methodology, or any similar or equivalent manual process, to access, acquire, copy or monitor
              any portion of the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or any Content, or in any way reproduce or circumvent the navigational structure or presentation of
              the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or any Content, to obtain or attempt to obtain any materials, documents or information through any
              means not purposely made available through the Platform. We reserve our right to prohibit any such
              activity.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You shall not attempt to gain unauthorized access to any portion or feature of the Platform, or any other
              systems or networks connected to the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or to any server, computer, network, or to any of the services offered on or through the Platform,
              by hacking, “password mining” or any other illegitimate means.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You shall not probe, scan or test the vulnerability of the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or any network connected to the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;nor breach the security or authentication measures on the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or any network connected to the Platform. You may not reverse look-up, trace or seek to trace any
              information on any other user of or visitor to Platform, or any other User, including any account on the
              ‘‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;not owned by you, to its source, or exploit the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or any service or information made available or offered by or through the Platform, in any way where
              the purpose is to reveal any information, including but not limited to personal identification or
              information, other than your own information, as provided for by the Platform.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You shall not make any negative, denigrating or defamatory statement(s) or comment(s) about us or the
              brand name or domain name used by us including the name&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              ‘Sporting’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              , or otherwise engage in any conduct or action that might tarnish the image or reputation, of&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or Vendor on ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or otherwise tarnish or dilute any&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting’s
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;trade or service marks, trade name and/or goodwill associated with such trade or service marks, as
              may be owned or used by us. You agree that you will not take any action that imposes an unreasonable or
              disproportionately large load on the infrastructure of the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting’s
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;systems or networks, or any systems or networks connected to&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              .
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              backgroundColor: "#ffffff",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You agree not to use any device, software or routine to interfere or attempt to interfere with the proper
              working of the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or any transaction being conducted on the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              , or with any other person’s use of the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              .
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              backgroundColor: "#ffffff",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You may not forge headers or otherwise manipulate identifiers in order to disguise the origin of any
              message or transmittal you send to us on or through the ‘‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or any service offered on or through the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              . You may not pretend that you are, or that you represent, someone else, or impersonate any other
              individual or entity.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You may not use the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;or any content on the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;for any purpose that is unlawful or prohibited by these Terms of Use, or to solicit the performance
              of any illegal activity or other activity that infringes the rights of&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;and/or others.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You shall at all times ensure full compliance with the applicable provisions, as amended from time to
              time, of (a) the Information Technology Act, (b) all applicable domestic laws, rules and regulations
              (including the provisions of any applicable exchange control laws or regulations in force); and (c)
              international laws, foreign exchange laws, statutes, ordinances and regulations (including, but not
              limited to sales tax, income tax, service tax, custom duty, local levies) regarding your use of our
              service and your listing, purchase, solicitation of offers to purchase, and sale of products or services.
              You shall not engage in any transaction in an item or service, which is prohibited by the provisions of
              any applicable law including exchange control laws or regulations for the time being in force.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              In order to allow us to use the information supplied by you, without violating your rights or any laws,
              you agree to grant us a non-exclusive, worldwide, perpetual, irrevocable, royalty-free, sub-licensable
              (through multiple tiers) right to exercise the copyright, publicity, database rights or any other rights
              you have in your Information, in any media now known or not currently known, with respect to your
              Information. We will only use your information in accordance with these Terms of Use and Privacy Policy
              applicable to use of the ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              .
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You shall not engage in advertising to, or solicitation of, other users of the Platform to buy or sell any
              products or services, including, but not limited to, products or services related to that being displayed
              on the Platform or related to us. You may not transmit any chain letters or unsolicited commercial or junk
              email to other users via the Platform. It shall be a violation of these Terms of Use to use any
              information obtained from the Platform in order to harass, abuse, or harm another person, or in order to
              contact, advertise to, solicit, or sell to another person other than us without our prior explicit
              consent. In order to protect our users from such advertising or solicitation, we reserve the right to
              restrict the number of messages or emails which a user may send to other users in any 24-hour period which
              we deem appropriate in its sole discretion. You understand that we have the right at all times to disclose
              any information (including the identity of the persons providing information or materials on the Platform)
              as necessary to satisfy any law, regulation or valid governmental request. This may include, without
              limitation, disclosure of the information in connection with investigation of alleged illegal activity or
              solicitation of illegal activity or in response to a lawful court order or summons. In addition, We can
              (and you hereby expressly authorize us to) disclose any information about you to law enforcement or other
              government officials, as we, in our sole discretion, believe necessary or appropriate in connection with
              the investigation and/or resolution of possible crimes, especially those that may involve personal injury.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              We reserve the right, but has no obligation, to monitor the materials posted on the Platform.&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;shall have the right to remove or edit any content that in its sole discretion violates, or is
              alleged to violate, any applicable law or either the spirit or letter of these Terms of Use.
              Notwithstanding this right, YOU REMAIN SOLELY RESPONSIBLE FOR THE CONTENT OF THE MATERIALS YOU POST ON THE
              PLATFORM AND IN YOUR PRIVATE MESSAGES. Please be advised that such Content posted does not necessarily
              reflect&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;views. In no event shall&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;assume or have any responsibility or liability for any Content posted or for any claims, damages or
              losses resulting from use of Content and/or appearance of Content on the Platform. You hereby represent
              and warrant that you have all necessary rights in and to all Content which you provide and all information
              it contains and that such Content shall not infringe any proprietary or other rights of third parties or
              contain any libelous, tortious, or otherwise unlawful information.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Your correspondence or business dealings with, or participation in promotions of, advertisers found on or
              through the Platform, including payment and delivery of related products or services, and any other terms,
              conditions, warranties or representations associated with such dealings, are solely between you and such
              advertiser. We shall not be responsible or liable for any loss or damage of any sort incurred as the
              result of any such dealings or as the result of the presence of such advertisers on the Platform.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;It is possible that other users (including unauthorized users or ‘hackers’) may post or transmit
              offensive or obscene materials on the Platform and that you may be involuntarily exposed to such offensive
              and obscene materials. It also is possible for others to obtain personal information about you due to your
              use of the Platform, and that the recipient may use such information to harass or injure you. We do not
              approve of such unauthorized uses, but by using the Platform You acknowledge and agree that we are not
              responsible for the use of any personal information that you publicly disclose or share with others on the
              Platform. Please carefully select the type of information that you publicly disclose or share with others
              on the Platform.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;shall have all the rights to take necessary action and claim damages that may occur due to your
              involvement/participation in any way on your own or through group/s of people, intentionally or
              unintentionally in DoS/DDoS (Distributed Denial of Services), hacking, pen testing attempts without our
              prior consent or a mutual legal agreement.
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol start={4} style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 700,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Account Registration or use of the Platform
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              backgroundColor: "#ffffff",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You may access the Platform by registering to create an account (“Sporting Account”) and become a member
              (“Membership”); The Membership is limited for the purpose and are subject to the terms, and strictly not
              transferable.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              backgroundColor: "#ffffff",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              We will create your Sporting Account for your use of the Platform services based upon the personal
              information you provide to us as described above. You may only have one Sporting Account and not permitted
              to create multiple accounts. If found, you are having multiple accounts, Sporting reserves right to
              suspend such multiple account without being liable for any compensation.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              backgroundColor: "#ffffff",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You agree to provide accurate, current and complete information during the registration process and to
              update such information to keep it accurate, current and complete.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              backgroundColor: "#ffffff",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              We reserve the right to suspend or terminate your Sporting Account and your access to the Services (i) if
              any information provided during the registration process or thereafter proves to be inaccurate, not
              current or incomplete; (ii) if it is believed that your actions may cause legal liability for you, other
              users or us; and/or (iii) if you are found to be non- compliant with the Terms of Use.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              backgroundColor: "#ffffff",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You are responsible for safeguarding your password. You agree that you will not disclose your password to
              any third party and that you will take sole responsibility for any activities or actions under your
              Sporting Account, whether or not you have authorized such activities or actions. You will immediately
              notify us of any unauthorized use of your Sporting Account.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              backgroundColor: "#ffffff",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Goods and services purchased from the Platform are intended for your personal use and you represent that
              the same are not for resale or you are not acting as an agent for other parties.
            </span>
          </p>
        </li>
      </ol>
      <p
        dir="ltr"
        style={{
          lineHeight: "1.7999999999999998",
          marginLeft: "36pt",
          textAlign: "justify",
          backgroundColor: "#ffffff",
          marginTop: "0pt",
          marginBottom: "0pt",
        }}
      >
        &nbsp;
      </p>
      <ol start={5} style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 700,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Bookings and Financial Terms
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The Platform allows you to place order bookings and we will, subject to the terms and conditions set out
              herein, enable delivery of such order to you.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;do not own, sell, resell on its own and/or do not control the Vendors or the related services
              provided in connection thereof. You understand that any order that you place shall be subject to the terms
              and conditions set out in these Terms of Use including, but not limited to, product availability and
              delivery location serviceability.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;As a general rule, all orders placed on the Platform are treated as confirmed.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              However, upon your successful completion of booking an order, we may call you on the telephone or mobile
              number provided to confirm the details of the order, the price to be paid and the estimated delivery time.
              For this purpose, you will be required to share certain information with us, including but not limited to
              (i) your first and last name (ii) mobile number; and (iii) address (iv) email address. It shall be your
              sole responsibility to bring any incorrect details to our attention.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              In addition to the foregoing, we may also contact you by phone and / or email to inform and confirm any
              change in the order, due to availability or unavailability or change in price of the order as informed by
              the Vendor. Please note change or confirmation of the order shall be treated as final. It is clarified
              that Sporting reserves the right to not to process your order in the event you are unavailable on the
              phone at the time we call you for confirming the order and such event the provisions of the cancellation
              and refund policy below shall be applicable.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              All payments made against the purchases/services on the Platform by you shall be compulsorily in Qatari
              Riyals acceptable in the State of Qatar. The Platform will not facilitate transactions with respect to any
              other form of currency with respect to the purchases made on Platform. You can pay by (i) credit card or
              debit card or net banking or cash at the time of delivery. You understand, accept and agree that the
              payment facility provided by&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;is neither a banking nor financial service but is merely a facilitator providing an electronic,
              automated online electronic payment, receiving payment on delivery, collection and remittance facility for
              the transactions on the Platform using the existing authorized banking infrastructure and credit card
              payment gateway networks. Further, by providing payment facility,&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;is neither acting as trustees nor acting in a fiduciary capacity with respect to the transaction or
              the transaction price.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You acknowledge and agree that we act as the Vendor’s payment agent for the limited purpose of accepting
              payments from you on behalf of the Vendor. Upon your payment of amounts to us, which are due to the
              Vendor, your payment obligation to the Vendor for such amounts is completed, and we are responsible for
              remitting such amounts, to the Vendor. You shall not, under any circumstances whatsoever, make any payment
              directly to the Vendor for Purchases/Bookings made using the Platform.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You agree to pay us for the total amount for the order placed by you on the Platform. We will collect the
              total amount in accordance with the terms and conditions of these Terms of Use and the pricing terms set
              forth in the applicable menu listing for the Vendor. Please note that we cannot control any amount that
              may be charged to you by your bank related to our collection of the total amount, and we disclaim all
              liability in this regard.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              In connection with your order, you will be asked to provide customary billing information such as name,
              billing address and credit card information either to us or our third-party payment processor. You agree
              to pay us for the order placed by you on the Platform, in accordance with these Terms, using of the
              methods described under clause 5 (6) above. You hereby authorize the collection of such amounts by
              charging the credit card provided as part of requesting the booking, either directly by us or indirectly,
              via a third-party online payment processor or by one of the payment methods described on the Platform. If
              you are directed to our third-party payment processor, you may be subject to terms and conditions
              governing use of that third party’s service and that third party’s personal information collection
              practices. Please review such terms and conditions and privacy policy before using the Platform services.
              Once your confirmed booking transaction is complete you will receive a confirmation email summarizing your
              confirmed booking.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The final tax bill will be issued by the Vendor to the Buyer along with the order and&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;is merely collecting the payment on behalf of such Vendor. All applicable taxes and levies, the
              rates thereof and the manner of applicability of such taxes on the bill are being charged and determined
              by the Vendor.&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;holds no responsibility for the legal correctness/validity of the levy of such taxes. The sole
              responsibility for any legal issue arising on the taxes shall reside with the Vendor.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The prices reflected on the&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              ‘Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;are determined solely by the Vendor and are listed based on Vendor’s information. Very rarely,
              prices may change at the time of placing order due to Vendor changing the menu price without due
              intimation and such change of price are at the sole discretion of the Vendor attributing to various
              factors beyond control.
            </span>
          </p>
        </li>
      </ol>
      <p
        dir="ltr"
        style={{
          lineHeight: "1.7999999999999998",
          marginLeft: "36pt",
          textAlign: "justify",
          marginTop: "0pt",
          marginBottom: "0pt",
        }}
      >
        <span
          style={{
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre-wrap",
          }}
        >
          Disclaimer: Prices on any product(s) as is reflected on the Platform may due to some technical issue,
          typographical error or product information supplied by Vendor be incorrectly reflected and in such an event
          Vendor may cancel such your order(s).
        </span>
      </p>
      <ol start={12} style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The Vendor shall be solely responsible for any warrantee/guarantee of the food products sold to the Users
              and in no event shall be the responsibility of&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              .
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The transaction is bilateral between the Vendor and User and therefore,&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;is not liable to charge or deposit any taxes applicable on such transaction.
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol start={6} style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 700,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Term of Service
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              That you agree and acknowledge that we shall not be responsible for.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "lower-alpha",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
            marginLeft: "18pt",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The services or goods provided by the Vendor including, but not limited to purchase of goods, food orders,
              appointment bookings, and services suiting your requirements and needs
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "lower-alpha",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
            marginLeft: "18pt",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The Vendor's services or goods not being up to your expectations or leading to any loss, harm or damage to
              you
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "lower-alpha",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
            marginLeft: "18pt",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The availability or unavailability of certain items listed on ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "lower-alpha",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
            marginLeft: "18pt",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The Vendor sending/booking/providing the incorrect products/services.
            </span>
          </p>
        </li>
      </ol>
      <ol start={2} style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The details of the price list available on the Platform are based on the information provided by the
              Vendors and we shall not be responsible for any change or cancellation or unavailability.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You may not be able to avail our Services if your delivery location is outside Sporting/Vendor current
              scope of Service. We will keep you informed of the same at the time of confirming your order booking.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You understand that delivery periods/pre-orders/pre-booked services quoted to you at the time of
              confirming the order is an approximate estimate and may vary.&nbsp;
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;will not be responsible for any delay in the delivery of your order.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              In the case of a deliverable item, Your order will be only delivered to the address designated by you at
              the time of placing the order on the Platform. We reserve the right to cancel the order, in our sole
              discretion, in the event of any change to the place of delivery and you shall not be entitled to any
              refund for the same. Delivery in the event of change of the delivery location shall be at our sole
              discretion.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You shall undertake to provide adequate directions, information and authorizations to accept a delivery or
              book a specific service. In the event of any failure to accept delivery/attend appointment or booking,
              failure to deliver within the estimated time due to your failure to provide appropriate instructions, or
              authorizations, then such goods and services shall be deemed to have been delivered to you and all risk
              and responsibility in relation to such goods shall pass to you and you shall not be entitled to any refund
              for the same. Our decision in relation to this shall be final and binding.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You understand that our liability ends once your service has been confirmed with all required
              documentation including payment slips(if applicable) to you.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You confirm that we shall not be responsible for any deficiency in payment of consideration payable
              towards the goods purchased from the Services
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Each Purchase or &nbsp;Service may contain necessary instructions to redeem the Services. The terms of the
              Services shall be governed by these Terms of Use and any other terms as set out in such document confirm
              such sale of Service. You shall not be entitled to receive any credit, refund or cash back for the value
              of the goods sold if you fail to redeem the goods within the expiry date or in accordance with the terms
              therein.
            </span>
          </p>
        </li>
      </ol>
      <ol start={10} style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You agree and acknowledge that neither us nor the Vendor shall be liable in the event of you failing to
              adhere to the Terms of Use
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You might be required to provide your credit or debit card details to the approved payment gateways while
              making the payment. In this regard, you agree to provide correct and accurate credit/ debit card details
              to the approved payment gateways for availing the Services. You shall not use the credit/ debit card which
              is not lawfully owned by you, i.e. in any transaction, you must use your own credit/ debit card. The
              information provided by you will not be utilized or shared with any third party unless required in
              relation to fraud verifications or by law, regulation or court order. You will be solely responsible for
              the security and confidentiality of your credit/ debit card details. We expressly disclaim all liabilities
              that may arise as a consequence of any unauthorized use of your credit/ debit card.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              We do not offer any refunds against goods already purchased from the Platform unless an error that is
              directly attributable to us has occurred during the purchase of such product or services.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              We constantly strive to provide you with accurate information on the Platform. However, in the event of an
              error, we may, in our sole discretion, contact you with further instructions
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              If you use the Platform, you do the same at your own risk.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You agree that the Services shall be provided by us only during the working hours of the relevant Vendors
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol start={7} style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 700,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Specific Terms with respect to Use of Platform for purchase of Medicines and Pharmaceutical Products which
              requires prescription
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You can use the Platform for purchase of various medicines and pharmaceutical products from the pharmacy
              stores that requires a valid medical prescription issued by a medical expert/ doctor to be provided to a
              registered pharmacist for the purpose of dispensing such medicines and pharmaceutical products
              (“Prescription Drugs”), offered for sale on the Platform by the Vendor. In order to purchase Prescription
              Drugs from the Vendor through the Platform, You are required to upload a scanned copy of the valid
              prescription on the Platform. The order would not be processed until a copy of a valid prescription is
              uploaded on the Platform. The Vendor will verify the prescription uploaded by you and in case of the
              Vendor observes any discrepancy in the prescription uploaded by you, the order will be cancelled
              immediately. You are also required to make the original prescription available at the time of receipt of
              delivery of the prescription drugs. You shall allow the delivery partner to stamp the original
              prescription at the time of medicine delivery failing which medicines will not be delivered.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You understand and agree that ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;is merely a technology platform and the medicines and pharmaceutical products are sold to you by the
              Vendor. ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;shall not be held responsible in any manner for any error or omission or act committed on part of
              the Vendor.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You provide right to ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;to share copy of the prescription uploaded by you with the Vendor for verification of the
              prescription and for the Vendor to dispense the prescription drugs accordingly.&nbsp;
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You agree and undertake that you will not repeat the use of prescription for which drugs have already been
              dispensed. In case, it is observed that you are repeating the use of prescription, the order will be
              cancelled immediately. In any event, ‘
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Sporting Application Channels/Platforms’
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;shall not be responsible for any adverse effects or harm caused to you if you repeat the use of
              prescription to order prescription drugs through the Platform.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You agree and confirm that you are completely aware of the indications, side effects, drug interactions,
              effects of missed doses or overdose of the medicines you order through the Platform. It is imperative to
              seek professional advice from your doctor before purchasing or consuming any medicine.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The Vendor/Sporting App shall maintain a record of the prescriptions uploaded by the Users.
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol start={8} style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 700,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Access to the Platform, Accuracy and security.
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              We endeavor to make the Platform available to during Vendor working hours. However, we do not represent
              that access to the Platform will be uninterrupted, timely, error free, free of viruses or other harmful
              components or that such defects will be corrected.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              We do not warrant that the Platform will be compatible with all hardware and software which you may use.
              We shall not be liable for damage to, or viruses or other code that may affect, any equipment (including
              but not limited to your mobile device), software, data or other property as a result of your download,
              installation, access to or use of the Platform or your obtaining any material from, or as a result of
              using, the Platform. We shall also not be liable for the actions of third parties.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              We do not represent or warranty that the information available on the Platform will be correct, accurate
              or otherwise reliable.
            </span>
          </p>
        </li>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              We reserve the right to suspend or withdraw access to the Platform to you personally, or to all users
              temporarily or permanently at any time without notice. We may any time at our sole discretion reinstate
              suspended users. A suspended User may not register or attempt to register with us or use the Platform in
              any manner whatsoever until such time that such user is reinstated by us.
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol start={9} style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 700,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Relationship with operators if the Platform is accessed on mobile devices.
            </span>
          </p>
        </li>
      </ol>
      <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "14pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              In the event the Platform is accessed on a mobile device, it is not associated, affiliated, sponsored,
              endorsed or in any way linked to any platform operator, including, without limitation, Apple, Google,
              Android or RIM Blackberry (each being an "&nbsp;Operator").
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Your download, installation, access to or use of the Platform is also bound by the terms and conditions of
              the Operator.
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You and we acknowledge that these Terms of Use are concluded between you and us only, and not with an
              Operator, and we, not those Operators, are solely responsible for the Platform and the content thereof to
              the extent specified in these Terms of Use.
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The license granted to you for the Platform is limited to a non-transferable license to use the Platform
              on a mobile device that you own or control and as permitted by these Terms of Use.
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              We are solely responsible for providing any maintenance and support services with respect to the Platform
              as required under applicable law. You and we acknowledge that an Operator has no obligation whatsoever to
              furnish any maintenance and support services with respect to the Platform.
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You and we acknowledge that we, not the relevant Operator, are responsible for addressing any claims of
              you or any third party relating to the Platform or your possession and/or use of the Platform, including,
              but not limited to: (i) any claim that the Platform fails to conform to any applicable legal or regulatory
              requirement; and (ii) claims arising under consumer protection or similar legislation.
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You and we acknowledge that, in the event of any third-party claim that the Platform or your possession
              and use of the Platform infringes that third party's intellectual property rights, we, not the relevant
              Operator, will be solely responsible for the investigation, defense, settlement and discharge of any such
              intellectual property infringement claim.
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You must comply with any applicable third-party terms of agreement when using the Platform (e.g. you must
              ensure that your use of the Platform is not in violation of your mobile device agreement or any wireless
              data service agreement).
            </span>
          </p>
        </li>
      </ol>
      <ol start={10} style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 700,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              You and we acknowledge and agree that the relevant Operator, and that Operator's subsidiaries, are third
              party beneficiaries of these Terms of Use, and that, upon your acceptance of these Terms of Use, that
              Operator will have the right (and will be deemed to have accepted the right) to enforce these Terms of Use
              against you as a third party beneficiary thereof.
            </span>
          </p>
        </li>
      </ol>
      <br />
      <p
        dir="ltr"
        style={{
          lineHeight: "1.7999999999999998",
          marginLeft: "18pt",
          textAlign: "justify",
          marginTop: "0pt",
          marginBottom: "0pt",
        }}
      >
        <span
          style={{
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 700,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre-wrap",
          }}
        >
          10. Disclaimers
        </span>
      </p>
      <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "14pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              THE PLATFORM MAY BE UNDER CONSTANT UPGRADES, AND SOME FUNCTIONS AND FEATURES MAY NOT BE FULLY OPERATIONAL.
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              DUE TO THE VAGARIES THAT CAN OCCUR IN THE ELECTRONIC DISTRIBUTION OF INFORMATION AND DUE TO THE
              LIMITATIONS INHERENT IN PROVIDING INFORMATION OBTAINED FROM MULTIPLE SOURCES, THERE MAY BE DELAYS,
              OMISSIONS, OR INACCURACIES IN THE CONTENT PROVIDED ON THE PLATFORM OR DELAY OR ERRORS IN FUNCTIONALITY OF
              THE PLATFORM. AS A RESULT, WE DO NOT REPRESENT THAT THE INFORMATION POSTED IS CORRECT IN EVERY CASE.
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              WE EXPRESSLY DISCLAIM ALL LIABILITIES THAT MAY ARISE AS A CONSEQUENCE OF ANY UNAUTHORIZED USE OF CREDIT/
              DEBIT CARDS.
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              YOU ACKNOWLEDGE THAT THIRD PARTY SERVICES ARE AVAILABLE ON THE PLATFORM. WE MAY HAVE FORMED PARTNERSHIPS
              OR ALLIANCES WITH SOME OF THESE THIRD PARTIES FROM TIME TO TIME IN ORDER TO FACILITATE THE PROVISION OF
              CERTAIN SERVICES TO YOU. HOWEVER, YOU ACKNOWLEDGE AND AGREE THAT AT NO TIME ARE WE MAKING ANY
              REPRESENTATION OR WARRANTY REGARDING ANY THIRD PARTY'S SERVICES NOR WILL WE BE LIABLE TO YOU OR ANY THIRD
              PARTY FOR ANY CONSEQUENCES OR CLAIMS ARISING FROM OR IN CONNECTION WITH SUCH THIRD PARTY INCLUDING, AND
              NOT LIMITED TO, ANY LIABILITY OR RESPONSIBILITY FOR, DEATH, INJURY OR IMPAIRMENT EXPERIENCED BY YOU OR ANY
              THIRD PARTY. YOU HEREBY DISCLAIM AND WAIVE ANY RIGHTS AND CLAIMS YOU MAY HAVE AGAINST US WITH RESPECT TO
              THIRD PARTY'S / VENDORS SERVICES.
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              SPORTING
            </span>
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              &nbsp;DISCLAIMS AND ALL LIABILITY THAT MAY ARISE DUE TO ANY VIOLATION OF THE FOOD SAFETY STANDARDS AND
              APPLICABLE RULES AND REGULATIONS MADE THEREUNDER AND SUCH LIABILITY SHALL BE ATTRIBUTABLE TO THE VENDOR.
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              WHILE THE MATERIALS PROVIDED ON THE PLATFORM WERE PREPARED TO PROVIDE ACCURATE INFORMATION REGARDING THE
              SUBJECT DISCUSSED, THE INFORMATION CONTAINED IN THESE MATERIALS IS BEING MADE AVAILABLE WITH THE
              UNDERSTANDING THAT WE MAKE NO GUARANTEES, REPRESENTATIONS OR WARRANTIES WHATSOEVER, WHETHER EXPRESSED OR
              IMPLIED, WITH RESPECT TO PROFESSIONAL QUALIFICATIONS, EXPERTISE, QUALITY OF WORK OR OTHER INFORMATION
              HEREIN. FURTHER, WE DO NOT, IN ANY WAY, ENDORSE ANY SERVICE OFFERED OR DESCRIBED HEREIN. IN NO EVENT SHALL
              WE BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DECISION MADE OR ACTION TAKEN IN RELIANCE ON SUCH
              INFORMATION.
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              THE INFORMATION PROVIDED HEREUNDER IS PROVIDED "AS IS". WE AND / OR OUR EMPLOYEES MAKE NO WARRANTY OR
              REPRESENTATION REGARDING THE TIMELINESS, CONTENT, SEQUENCE, ACCURACY, EFFECTIVENESS OR COMPLETENESS OF ANY
              INFORMATION OR DATA FURNISHED HEREUNDER OR THAT THE INFORMATION OR DATA PROVIDED HEREUNDER MAY BE RELIED
              UPON. MULTIPLE RESPONSES MAY USUALLY BE MADE AVAILABLE FROM DIFFERENT SOURCES AND IT IS LEFT TO THE
              JUDGEMENT OF USERS BASED ON THEIR SPECIFIC CIRCUMSTANCES TO USE, ADAPT, MODIFY OR ALTER SUGGESTIONS OR USE
              THEM IN CONJUNCTION WITH ANY OTHER SOURCES THEY MAY HAVE, THEREBY ABSOLVING US AS WELL AS OUR CONSULTANTS,
              BUSINESS ASSOCIATES, AFFILIATES, BUSINESS PARTNERS AND EMPLOYEES FROM ANY KIND OF PROFESSIONAL LIABILITY.
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              WE SHALL NOT BE LIABLE TO YOU OR ANYONE ELSE FOR ANY LOSSES OR INJURY ARISING OUT OF OR RELATING TO THE
              INFORMATION PROVIDED ON THE PLATFORM. IN NO EVENT WILL WE OR OUR EMPLOYEES, AFFILIATES, AUTHORS OR AGENTS
              BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DECISION MADE OR ACTION TAKEN BY YOUR RELIANCE ON THE CONTENT
              CONTAINED HEREIN.
            </span>
          </p>
        </li>
        <li
          aria-level={2}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "14pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              IN NO EVENT WILL WE BE LIABLE FOR ANY DAMAGES (INCLUDING, WITHOUT LIMITATION, DIRECT, INDIRECT,
              INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES, DAMAGES ARISING FROM PERSONAL INJURY/WRONGFUL
              DEATH, AND DAMAGES RESULTING FROM LOST PROFITS, LOST DATA OR BUSINESS INTERRUPTION), RESULTING FROM ANY
              SERVICES PROVIDED BY ANY THIRD PARTY OR VENDOR ACCESSED THROUGH THE PLATFORM, WHETHER BASED ON WARRANTY,
              CONTRACT, TORT, OR ANY OTHER LEGAL THEORY AND WHETHER OR NOT WE ARE ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGES.
            </span>
          </p>
        </li>
      </ol>
      <ol start={11} style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 700,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Governing law and dispute resolution
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              marginRight: "5.05pt",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              These Terms of Use are governed by the laws of Qatar. Any action, suit, or other legal proceeding, which
              is commenced to resolve any matter arising under or relating to this Platform, shall be subject to the
              jurisdiction of the courts at Qatar shall be applied, in particular the Commercial Companies Law No. (11)
              of 2015.
            </span>
          </p>
        </li>
      </ol>
      <br />
      <ol start={12} style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
        <li
          aria-level={1}
          dir="ltr"
          style={{
            listStyleType: "decimal",
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 700,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "underline",
            WebkitTextDecorationSkip: "none",
            textDecorationSkipInk: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre",
          }}
        >
          <p
            dir="ltr"
            style={{
              lineHeight: "1.7999999999999998",
              textAlign: "justify",
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span
              style={{
                fontSize: "10.5pt",
                fontFamily: '"Helvetica Neue",sans-serif',
                color: "#62646a",
                backgroundColor: "transparent",
                fontWeight: 700,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Contact us
            </span>
          </p>
        </li>
      </ol>
      <br />
      <p
        dir="ltr"
        style={{
          lineHeight: "1.295",
          marginLeft: "36pt",
          textAlign: "justify",
          marginTop: "0pt",
          marginBottom: "0pt",
        }}
      >
        <span
          style={{
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre-wrap",
          }}
        >
          If you have any queries relating to the processing or usage of information provided by you in connection with
          this Policy, please email us at qureapplication@info.com or contact our office address&nbsp;
        </span>
      </p>
      <br />
      <p
        dir="ltr"
        style={{
          lineHeight: "1.295",
          marginLeft: "36pt",
          marginTop: "0pt",
          marginBottom: "0pt",
        }}
      >
        <span
          style={{
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 700,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre-wrap",
          }}
        >
          Sporting Application
        </span>
        <span
          style={{
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre-wrap",
          }}
        >
          &nbsp;
        </span>
        <span
          style={{
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre-wrap",
          }}
        >
          <br />
        </span>
        <span
          style={{
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre-wrap",
          }}
        >
          Address: Marina Twin Towers, Tower A, Floor 17, Office 171, Lusail City.
        </span>
      </p>
      <p
        dir="ltr"
        style={{
          lineHeight: "1.295",
          marginLeft: "36pt",
          marginTop: "0pt",
          marginBottom: "0pt",
        }}
      >
        <span
          style={{
            fontSize: "10.5pt",
            fontFamily: '"Helvetica Neue",sans-serif',
            color: "#62646a",
            backgroundColor: "transparent",
            fontWeight: 400,
            fontStyle: "normal",
            fontVariant: "normal",
            textDecoration: "none",
            verticalAlign: "baseline",
            whiteSpace: "pre-wrap",
          }}
        >
          Tel: +974 330330000
        </span>
      </p>
    </Box>
  );
};

export default Terms;
